import React from "react";
import { useState, useEffect } from "react";
import { partnerService } from "../../services/api/partner.service";
import { filesService } from "../../services/api/files.service";
import { FileListAddFile } from "./fileListAddFile";
import { alertService } from "../../services/helpers/alert.service";
import { utils } from "../../services/helpers/utils";

export const FilesList = (props) => {

    const [files, setFiles] = useState([]);
    const [visibleDialog, setVisibleDialog] = React.useState(false);
    const [refresh, setRefresh] = useState(true);

    const partener = sessionStorage.getItem("idPartener");
    

    const toggleDialog = () => {
        setVisibleDialog(!visibleDialog);
        setRefresh(!refresh);
    };

    useEffect(() => {
        if (refresh === false) return;

        if (partener != 0) {
            partnerService.getFiles({ partener: partener })
                .then(response => {
                    if (response) {
                        setFiles(response);
                    }
                    else {
                        setFiles(null);
                    }
                });
        }
        else {
            alertService.error('Selecteaza un partener!')
            return;
        }
        setRefresh(false);
    }, [refresh]);


    const handleDownload = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.downloadFile({ queryString: item.downloadId,  partener });
        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
    }

    const handleView = (item) => {
        // Daca are downloadId inseamna ca fisierul a fost salvat in baza de date
        if (item.hasOwnProperty("downloadId")) {
            filesService.getFile({ queryString: item.downloadId, partener: partener })
                .then(response => {
                    if (response) {
                        utils.viewResponse(response, item.nume)
                    }
                })


        }
        else {
            utils.downloadFilebyName(item.fisier, item.nume);
        }
        return;
    }


    const handleDelete = (id) => {
        alertService.confirm("Atentie", "Esti sigura ca vrei sa stergi fisierul?"
            , () => { partnerService.deleteFile({ id: files[id].id }).then((response) => { setRefresh(true); }); }
            , () => { return; }
        );

    }

    return (
        <>
            {files &&
                <>
                    <div className="clearfix">
                        <h2 className="fl">Lista fisiere</h2>
                        <div className="fr d-flex justify-content-end">
                            <button name="add"
                                className="btn db"
                                value="Adauga fisier"
                                onClick={toggleDialog}
                            >Adauga fisier

                            </button>
                        </div>
                    </div>
                    <div data-name="mesaj"></div>
                    <table className="tbl" data-name="lista" width="100%">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Denumire</th>
                                <th>Descriere</th>
                                <th>Dimensiune</th>
                                <th width="100"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {files.map((file, index) => (
                                <tr key={index}>
                                    <td data-name="data">{file.data}</td>
                                    <td data-name="nume_fisier">{file.nume}</td>
                                    <td data-name="descriere">{file.descriere}</td>
                                    <td data-name="dimensiune">{file.dimensiune}</td>
                                    <td>
                                        <a className="icon sterge ml10 mr10 fl"
                                            onClick={() => handleDelete(index)}
                                            data-name="del" title="Sterge">Sterge</a>

                                        <a className="icon deschide mr10 fl"
                                            onClick={() => handleView(file)}
                                            data-name="view"
                                            title="Vizualizeaza">Vizualizeaza</a>

                                        <a className="icon download fl"
                                            onClick={() => handleDownload(file)}
                                            data-name="download"
                                            title="Download">Download</a>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                </table>
                {visibleDialog && <FileListAddFile toggleDialog={toggleDialog}  />}
                </>
            }
        </>
    );
};
